import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ScheduleData } from '../types';
import { widgetDayLabel } from './widgetFormat';

type Props = {
  data: ScheduleData;
};

const UpcomingScheduleWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const { t } = useTranslation();

  const TYPE_LABELS: Record<string, string> = {
    work: t('aiChat.widgets.schedule.work'),
    pto: t('aiChat.widgets.schedule.pto'),
    holiday: t('aiChat.widgets.schedule.holiday'),
  };
  if (data.days.length === 0) {
    return (
      <div className="ai-chat-widget ai-chat-widget-schedule">
        <div className="ai-chat-widget-schedule-empty">
          {t('aiChat.widgets.schedule.noEntries')}
        </div>
      </div>
    );
  }

  return (
    <div className="ai-chat-widget ai-chat-widget-schedule">
      {data.days.map((day, idx) => (
        <div key={idx} className="ai-chat-widget-schedule-row">
          <span className="ai-chat-widget-schedule-date">
            {widgetDayLabel(day.date, day.dayLabel)}
          </span>
          <span
            className={`ai-chat-widget-schedule-badge ai-chat-widget-schedule-badge-${day.type}`}>
            {day.label ?? TYPE_LABELS[day.type] ?? day.type}
          </span>
          {day.hours != null && (
            <span className="ai-chat-widget-schedule-hours">{day.hours}h</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default UpcomingScheduleWidget;
